
import tagableMixin from "~/mixins/tagableMixin";

export default {
  mixins: [tagableMixin],

  props: {
    selectedVariant: { type: Object, default: () => {} },
    tags: { type: Array, default: () => [] },
  },

  computed: {
    comProperties() {
      const {
        width,
        height,
        depth,
        variant_weight: variantWeight,
      } = this.selectedVariant;

      return { width, height, depth, variantWeight, tags: this.tags };
    },
    featurePanels() {
      let featurePanels = [];
      if (this.productHasSize) {
        featurePanels.push({
          title: this.selectedVariant?.variant_weight
            ? "dimensions & weight"
            : "dimensions",
          component: "PdpDimension",
          props: this.comProperties,
        });
      }

      if (this.selectedVariant.warranty) {
        featurePanels.push({
          title: "care & warranty",
          component: "PdpCareWarranty",
          props: {},
        });
      }

      if (this.selectedVariant.delivery_truck) {
        featurePanels.push({
          title: "2 person delivery service",
          component: "PdpDeliveryService",
          props: {},
        });
      }
      return featurePanels;
    },
    productHasSize() {
      return (
        this.selectedVariant.width != null &&
        this.selectedVariant.height != null &&
        this.selectedVariant.depth != null
      );
    },
  },
};
